import { connect } from "react-redux";
import { toggleLoading, setAlert } from "../../state/creators";
import { ModalWrapper, ModalContent, ModalClose, ModalHeader } from "../../styles/modals";
import { H2 } from "../../styles/type/headings";
import { DocumentInterface } from "../../_types/document";
import FilePreview from "../documents/preview";

type Props = {
	closeModal: () => void;
	document: DocumentInterface;
};

const FilePreviewModal = ({ closeModal, document }: Props) => {
	return (
		<>
			<ModalWrapper large>
				<ModalHeader>
					<H2>Preview File</H2>
					<ModalClose onClick={closeModal}>close</ModalClose>
				</ModalHeader>
				<ModalContent>{document ? <FilePreview document={document} closeModal={closeModal} /> : null}</ModalContent>
			</ModalWrapper>
		</>
	);
};

const mapDispatchToProps = {
	toggleLoading,
	setAlert,
};

export default connect(null, mapDispatchToProps)(FilePreviewModal);
